import type { UserData } from '@/features/auth'
import { authApi } from '@/services/api/auth/api'

export const useAuthUser = (user = null): UserData => {
  const state = authApi.endpoints.getUser.useQuery(user)
  return state.data as UserData
}
